import { AlbumDetails as AlbumDetailsModule } from "../modules/OperatorAlbumDetails/albumDetails";

const OperatorAlbumDetails = () => {
  return <AlbumDetailsModule />;
};

export default OperatorAlbumDetails;
